import { IPatientWaitingListState } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";
import { usePatientWaitingStatsAPI } from "../PWL/usePatientWaitingStatsAPI";

const useRefetchPWLStats = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("PATIENT_WAITING_LIST", "id"));
  const { filters: PWLFilters } = routeState.state as IPatientWaitingListState;
  const fetchPWLStats = usePatientWaitingStatsAPI();
  const execute = async () => {
    if (Object.keys(PWLFilters ?? {})?.length > 0) {
      await fetchPWLStats(PWLFilters);
    }
  };
  return execute;
};

export default useRefetchPWLStats;
